import { environment } from 'src/environments/environment';

export class Base {
    apiUrl = environment.apiUrl;
    
    detectMob() {
        return ( window.innerWidth <= 800  );
    }
}
